import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dtwin-state-table"
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.deleteConfirmation'),
      "open": _vm.showDeleteDialog,
      "value": _vm.confirmDeleteId,
      "color": "red",
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        color: 'red',
        emit: 'delete',
        disabled: _vm.linkedStateAggregations === null || !_vm.canDeleteState
      }]
    },
    on: {
      "close": function ($event) {
        _vm.showDeleteDialog = false;
      },
      "delete": _vm.handleConfirmDelete
    }
  }, [_vm.linkedStateAggregations && _vm.linkedStateAggregations.length ? [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.deleteAggregateText')) + "\n      "), _c(VTreeview, {
    staticClass: "mt-2 infoTree",
    attrs: {
      "items": _vm.linkedStateAggregations,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function ({
        item
      }) {
        return [item.icon ? _c(VIcon, {
          staticStyle: {
            "width": "25px"
          },
          attrs: {
            "size": "16"
          },
          domProps: {
            "textContent": _vm._s(`fal fa-${item.icon}`)
          }
        }) : _vm._e()];
      }
    }, {
      key: "label",
      fn: function ({
        item
      }) {
        return [item.isTwin ? [_c('a', {
          attrs: {
            "href": `/#/${item.twinType === 'virtualDevice' ? 'virtual-devices' : 'digitaltwin-mgmt'}/${item.id}`,
            "target": "_blank"
          }
        }, [_vm._v("\n              " + _vm._s(item.title) + "\n            ")])] : [_vm._v("\n            " + _vm._s(item.title) + "\n          ")], _vm._v("\n           \n          "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 1373246036)
  })] : _vm._e()], 2), _c(VDialog, {
    attrs: {
      "dark": _vm.UiTheme,
      "max-width": "1000px",
      "persistent": ""
    },
    model: {
      value: _vm.stateEditDialog,
      callback: function ($$v) {
        _vm.stateEditDialog = $$v;
      },
      expression: "stateEditDialog"
    }
  }, [_vm.stateEditDialog ? _c(_vm.editDialogComponent, {
    tag: "component",
    attrs: {
      "tenantId": _vm.tenantId,
      "mode": _vm.getStateEditMode,
      "deviceTemplate": _vm.deviceTemplate,
      "otherStates": _vm.value,
      "dataSources": _vm.dataSources,
      "bridgeConfigs": _vm.bridgeConfigs,
      "twinType": _vm.isVirtualDevice ? 'virtualDevice' : undefined,
      "twinModel": _vm.twinModel
    },
    on: {
      "close": _vm.closeEditWithError,
      "save": _vm.saveState,
      "stateUpdated": function ($event) {
        _vm.$emit('statesUpdated');
        _vm.closeEditWithError();
      }
    },
    model: {
      value: _vm.stateEditItem,
      callback: function ($$v) {
        _vm.stateEditItem = $$v;
      },
      expression: "stateEditItem"
    }
  }) : _vm._e()], 1), _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.showHistoryDialog,
      "max-width": "95%"
    },
    on: {
      "close": function ($event) {
        _vm.showHistoryDialog = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.history')))];
      },
      proxy: true
    }])
  }, [_vm.showHistoryDialog && _vm.historyState ? _c('core-dtwin-state-history', {
    ref: "dtwin-state-history",
    attrs: {
      "state": _vm.historyState
    }
  }) : _vm._e()], 1), _c(VDialog, {
    attrs: {
      "dark": _vm.UiTheme,
      "max-width": "1200px"
    },
    model: {
      value: _vm.stateDisplayDialog,
      callback: function ($$v) {
        _vm.stateDisplayDialog = $$v;
      },
      expression: "stateDisplayDialog"
    }
  }, [_c('material-card', {
    class: 'pt-2 pb-0 pl-0 dtwin-state-table' + (_vm.$vuetify.breakpoint.xsOnly ? ' xs' : '')
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, [_c(VCardTitle, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('Common.search'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "clearable": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-sync"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('refresh');
            }
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1)], 1)], 1), _c(VDataTable, {
    attrs: {
      "headers": _vm.tableLocalizations.dialogHeaders,
      "items": _vm.value,
      "search": _vm.search,
      "footer-props": _vm.tableLocalizations.dialogFooterProps,
      "sort-by": ['title'],
      "sort-desc": [false],
      "item-key": "id",
      "hide-default-header": ""
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function (headerProps) {
        return [_c('thead', {
          staticClass: "v-data-table-header"
        }, [_c('tr', _vm._l(headerProps.props.headers, function (header) {
          return _c('th', {
            key: `dialog_table_${header.key}`,
            class: _vm.detailTableHeaderColClass(header, headerProps.props)
          }, [header.value === 'key' ? [_vm._v(" ")] : header.value === 'title' ? [_c('span', {
            class: _vm.detailTableHeaderClasses(headerProps.props).text.title,
            on: {
              "click": function ($event) {
                return headerProps.on.sort(header.value);
              }
            }
          }, [_vm._v("\n                    " + _vm._s(header.text) + "\n                  ")]), _c(VIcon, {
            class: `${_vm.detailTableHeaderClasses(headerProps.props).icon.title}`,
            attrs: {
              "size": "18"
            }
          }, [_vm._v("\n                    fas fa-sort-up\n                  ")]), _vm._v("\n                  / (\n                  "), _c('span', {
            class: _vm.detailTableHeaderClasses(headerProps.props).text.key,
            on: {
              "click": function ($event) {
                return headerProps.on.sort('key');
              }
            }
          }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.key')) + "\n                  ")]), _c(VIcon, {
            class: `${_vm.detailTableHeaderClasses(headerProps.props).icon.key}`,
            attrs: {
              "size": "18"
            }
          }, [_vm._v("\n                    fas fa-sort-up\n                  ")]), _vm._v("\n                  )\n                ")] : [_c('span', {
            on: {
              "click": function ($event) {
                return headerProps.on.sort(header.value);
              }
            }
          }, [_vm._v(_vm._s(header.text))]), header.sortable ? _c(VIcon, {
            staticClass: "v-data-table-header__icon",
            attrs: {
              "size": "18"
            }
          }, [_vm._v("fas fa-sort-up")]) : _vm._e()]], 2);
        }), 0)])];
      }
    }, {
      key: "item",
      fn: function (props) {
        return [_c('tr', [_c('td', {
          staticClass: "text-center"
        }, [props.item.properties.faIcon ? _c(VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-" + _vm._s(props.item.properties.faIcon))]) : _vm._e()], 1), _c('td', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(props.item.id))]), _c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n              " + _vm._s(props.item.properties.title) + "\n              "), _c('br'), _vm._v("\n              (" + _vm._s(props.item.key) + ")\n            ")]), _c('td', {
          staticClass: "text-left"
        }), _c('td', {
          staticClass: "text-left state-value-item"
        }, [_vm.displayType(props.item) === 'code' ? [_c('codemirror', {
          staticClass: "detail-dialog",
          attrs: {
            "options": _vm.cmOptions,
            "value": _vm.outputValue(props.item)
          }
        })] : [_vm._v("\n                " + _vm._s(_vm.outputValue(props.item)) + "\n              ")]], 2), _c('td', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(props.item.properties.unit))]), _c('td', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm.localizeDate(props.item)))]), _c('td', {
          staticClass: "text-center"
        }, [_c('core-dtwin-state-table-source-icon', {
          attrs: {
            "dataSources": _vm.dataSources,
            "bridgeConfigs": _vm.bridgeConfigs,
            "item": props.item,
            "showName": true
          }
        })], 1), _c('td', {
          staticClass: "text-center"
        }, [_c(VIcon, {
          attrs: {
            "data-cy": "showhistory_icon",
            "color": _vm.color,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.showHistory(props.item);
            }
          }
        }, [_vm._v("\n                fal fa-calendar-alt\n              ")])], 1), _c('td', {
          staticClass: "text-center"
        }, [!_vm.disabled ? _c(VIcon, {
          attrs: {
            "data-cy": "edit_icon",
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.edit'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.editState(props.item);
            }
          }
        }, [_vm._v("\n                fal " + _vm._s(_vm.detailButtonIcon) + "\n              ")]) : _vm._e(), _vm.mode !== 'editonly' ? [_vm._v("\n                 \n                "), !_vm.disabled && _vm.hasTwinManagePermission && _vm.isStateDeletable(props.item) ? _c(VIcon, {
          attrs: {
            "data-cy": "delete_icon",
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.deleteState(props.item.id);
            }
          }
        }, [_vm._v("\n                  fal fa-trash-alt\n                ")]) : _vm._e()] : _vm._e()], 2)])];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_vm._v("\n          " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n        ")];
      }
    }])
  })], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "buttons": _vm.actionButtons
    },
    on: {
      "exportModal": _vm.exportModal,
      "addItem": _vm.addItem,
      "stateView": _vm.stateView
    }
  }, [_c(VDataTable, {
    class: `mt-2 mb-2 states-table ${_vm.themeMode}`,
    attrs: {
      "headers": _vm.tableLocalizations.headers,
      "footer-props": _vm.tableLocalizations.dialogFooterProps,
      "items": _vm.value,
      "sort-by": ['properties.orderIdx'],
      "search": _vm.search,
      "item-key": "id",
      "options": _vm.tableOptions
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (props) {
        return [_vm.$vuetify.breakpoint.xsOnly ? _c('tr', {
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_c('td', {
          staticClass: "text-left",
          attrs: {
            "colspan": "5"
          },
          on: {
            "click": function ($event) {
              if (_vm.tenantId) {
                _vm.editState(props.item);
              }
            }
          }
        }, [_c('ul', {
          staticClass: "flex-content",
          staticStyle: {
            "padding-left": "0px"
          }
        }, [_c('li', {
          staticClass: "flex-item"
        }, [_c('span', {
          staticClass: "flex-item-label"
        }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.title')))]), _c('br'), _c('span', {
          staticClass: "flex-item-content"
        }, [_vm._v(_vm._s(props.item.properties.title))])]), _c('li', {
          staticClass: "flex-item"
        }, [_c('span', {
          staticClass: "flex-item-label"
        }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.value')))]), _c('br'), _c('span', {
          staticClass: "flex-item-content value-item"
        }, [_vm._v("\n                      " + _vm._s(_vm.outputValue(props.item)) + " " + _vm._s(props.item.properties.unit) + "\n                    ")])]), _c('li', {
          staticClass: "flex-item"
        }, [_c('span', {
          staticClass: "flex-item-label"
        }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.source')))]), _c('br'), _c('span', {
          staticClass: "flex-item-content"
        }, [_c('core-dtwin-state-table-source-icon', {
          attrs: {
            "dataSources": _vm.dataSources,
            "bridgeConfigs": _vm.bridgeConfigs,
            "item": props.item
          }
        })], 1)])])]), _c('td', {
          staticClass: "text-right"
        }, [!_vm.disabled && _vm.hasTwinManagePermission ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.deleteState(props.item.id);
            }
          }
        }, [_vm._v("\n                  fal fa-trash-alt\n                ")]) : _vm._e()], 1)]) : _c('tr', {
          key: `state-row-${props.item.id}`
        }, [_c('td', {
          class: `text-center ${_vm.blockStateOrdering ? '' : 'handle'}`
        }, [_c(VIcon, {
          style: `opacity: ${_vm.blockStateOrdering ? 0.5 : 1}`,
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-arrows")])], 1), _c('td', {
          staticClass: "text-center"
        }, [props.item.properties.faIcon ? _c(VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-" + _vm._s(props.item.properties.faIcon))]) : _vm._e()], 1), _c('td', {
          staticClass: "text-left state-value-item"
        }, [_vm._v("\n                " + _vm._s(props.item.id) + "\n              ")]), _c('td', {
          staticClass: "text-left"
        }, [_c('div', {
          staticClass: "text-truncate",
          attrs: {
            "title": props.item.properties.title
          }
        }, [_vm._v("\n                  " + _vm._s(props.item.properties.title) + "\n                ")])]), _c('td', {
          staticClass: "text-left state-value-item",
          attrs: {
            "data-cy": `state-value-${props.item.key}`
          }
        }, [_vm.displayType(props.item) === 'code' ? [_c('div', {
          staticClass: "text-truncate"
        }, [_vm._v(_vm._s(_vm.outputValue(props.item).slice(0, 100)))])] : [_vm._v("\n                  " + _vm._s(_vm.outputValue(props.item)) + "\n                ")]], 2), _c('td', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(props.item.properties.unit))]), _c('td', {
          staticClass: "text-center"
        }, [_c('core-dtwin-state-table-source-icon', {
          attrs: {
            "dataSources": _vm.dataSources,
            "bridgeConfigs": _vm.bridgeConfigs,
            "item": props.item
          }
        })], 1), _c('td', {
          staticClass: "text-right"
        }, [_c(VIcon, {
          staticClass: "mr-4",
          attrs: {
            "data-cy": `showHistory_btn_${props.item.key}`,
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.showHistory'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.showHistory(props.item);
            }
          }
        }, [_vm._v("\n                  fal fa-calendar-alt\n                ")])], 1), _vm.mode !== 'lite' ? _c('td', {
          staticClass: "text-left"
        }, [!_vm.disabled ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.edit'),
            "small": "",
            "data-cy": `editState_btn_${props.item.key}`
          },
          on: {
            "click": function ($event) {
              return _vm.editState(props.item);
            }
          }
        }, [_vm._v("\n                  fal " + _vm._s(_vm.detailButtonIcon) + "\n                ")]) : _vm._e(), _vm.mode !== 'editonly' ? [_vm._v("\n                   \n                  "), _c(VTooltip, {
          attrs: {
            "left": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on
            }) {
              return [_c('div', _vm._g({
                staticStyle: {
                  "display": "inline"
                }
              }, on), [!_vm.disabled && _vm.hasTwinManagePermission && _vm.isStateDeletable(props.item) ? _c(VIcon, {
                attrs: {
                  "disabled": _vm.isCreatedByTemplate,
                  "color": _vm.color,
                  "title": _vm.$i18n_t('Common.delete'),
                  "small": "",
                  "data-cy": "deleteState_btn"
                },
                on: {
                  "click": function ($event) {
                    return _vm.deleteState(props.item.id);
                  }
                }
              }, [_vm._v("\n                          fal fa-trash-alt\n                        ")]) : _vm._e()], 1)];
            }
          }], null, true)
        }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.dataStatesConfigured', {
          deviceTemplateTitle: _vm.deviceTemplate ? _vm.deviceTemplate.title : null
        })) + "\n                  ")])] : _vm._e()], 2) : _vm._e()])];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_vm._v("\n            " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n          ")];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n            ")])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };